import { usePage } from "@inertiajs/react";

export default function customUsePage<T = any>() {
  return usePage<T & CommonUsePageProps>();
}

export {router} from "@inertiajs/react";